import React,{ useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom';

export default function Footer(props) {
    
	const [scrollState, setScrollState] = useState('');

	const [scrollPosition, setScrollPosition] = useState('');
	const [hieght, setHeight] = useState('');
	const [d, setD] = useState('block');

	// const handleScroll = () => {
	// 	if (typeof window !== "undefined") {
	// 	window.onscroll = () => {
	// 		let currentScrollPos = window.pageYOffset;
	// 		let maxScroll = document.body.scrollHeight - window.innerHeight;
	// 		console.log(maxScroll)
	// 		console.log(currentScrollPos)
	// 		if (currentScrollPos < 10) {
    //             console.log(currentScrollPos + "b")
	// 			setD('block')
	// 		} else {
	// 			setD('none')
	// 		}
	// 	}
	// 	}

	// };

	// useEffect(() => {
	// 	window.addEventListener('scroll', handleScroll, { passive: true });

	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, []);


    return (
        <>
            <section id='footer' className={`footer ${d === 'block' ? 'display-b' : 'display-n'} `}>
                <ul>
                {props.footerData && props.footerData.map((item,index) => {
                            return(
                                <li key={index} className="nav-item">
                                    <NavLink to={item.to} className="nav-link">{item.label}</NavLink> 
                                </li>
                            )
                        })}
                </ul>
            </section>
        </>
    )
}
